import { AccountSettingsCard } from "../../../components/ops/AccountSettingsCard";
import { PageHeader } from "../../../components/ops/PageHeader";

export function CoachSettingsPage() {
  return (
    <div>
      <PageHeader title="Settings" subtitle="Manage your coach profile" />
      <AccountSettingsCard />
    </div>
  );
}
